<script>
import Multiselect from 'vue-multiselect'
import UploadFile from '@components/upload-file'

export default {

    components: { Multiselect, UploadFile },

    props: {

    },

    data() {
        return {}
    },

    watch: {

    },

    computed: {

    },

    async mounted() {

    },

    methods: {

    }
}
</script>

<template>
    <div>
        <b-form-group
            label="Параметры"
            label-for="set_variables"
        >
            <b-form-textarea
                id="operation"
                v-model="$parent.condition.operation"
                placeholder="$var1 == 'текст' || $var2 == 123"
                rows="4"
            ></b-form-textarea>
        </b-form-group>

        <b-form-group
            label="Перейти к блоку, в случае выполнения условия"
            label-for="condition_action"
        >
            <b-form-input
                id="condition_action"
                v-model="$parent.condition.action"
                placeholder="Укажите ID блока или оставьте пустым"
            ></b-form-input>
        </b-form-group>

    </div>
</template>
